
import React, { useState, useContext, useEffect } from 'react';
import '../../../styles/casedetails.css';
import { Outlet, Link, useNavigate, Navigate } from 'react-router-dom';
import { ShareContext } from '../../../context/ShareContext'
import * as Constants from '../../../constants';
import JisButton from '../../controls/jisButton';

function ViewMotions({caseId, motions=null, isAction=false}) {
  const navigate = useNavigate();
    const {  activePage, token, profile,frequentData, setIsExpired} = useContext(ShareContext);
       
    const [loading, setLoading] =useState(false);
    const [_motions, setMotions] = useState(motions);
    
    useEffect(() => {
        
          /*  if(motions==null){
            onLoad();
          } */

      }, [motions]);
    
      const onLoad= async()=>{
        //for account registration
        try {
          setLoading(true);
            const resp = await fetch(`${Constants.apiUrl}/filing/case-details/${caseId}/motions`, { 
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
              },
            });
            
            const data = await resp.json();
            if(data.code==0){
              setMotions(data.motions);
            } else if(data.code==-10){
                      setIsExpired(true);
                  }
          } catch (error) {
            setLoading(false);
            console.error(error);
            
          }
    }
       const onFilingMotion=()=>{
        navigate(`/filing-motion/${caseId}`);
      } 
      
      
  return (
    <div>
   {isAction &&  <div style={{textAlign:'right'}}>
       <JisButton onClick={onFilingMotion}>CLICK HERE TO FILE ADDITIONAL MOTION</JisButton>
     </div>}  
    <div className='motions'>
       {_motions.map((opt) => ( 
               <div class="motion-card" key={opt.id}>
    <div class="motion-section">
      <div class="motion-left">
        <p><strong>Prayers</strong></p>
        <ol> 
           {opt.prayers?.map((pray,ind) => ( 
                   <li key={pray.id} style={{gap:10, display:'flex'}}><span>{ind+1}.</span><span>{pray.prayer}</span> </li>
            ))}
        </ol>
        
      </div>
      <div class="motion-divider"></div>
      <div class="motion-right">
        <p><strong>Party Name: </strong> {opt.party.firstName} {opt.party.lastName??''}</p>
        <p><strong>Motion Type: </strong> {opt.motiontype}</p>
        <p><strong>Classification: </strong>{opt.motionClass}</p>
        <p><strong>Date Filed: </strong> {Constants.momentDate(opt.createdOn).format('DD MMM, YYYY')}</p>
      </div>
    </div>
  </div>      
            ))}
            

    </div>
    </div>
  );
}

export default ViewMotions;